// src/features/Analytics/hooks/useResourcePredictions.js
import { useState, useEffect, useCallback } from 'react';
import { MLResourcePredictor } from '../mlResourcePredictor';
import { getData } from '../../../services/storageService';

export const useResourcePredictions = (productionPredictions = []) => {
  const [predictor] = useState(() => new MLResourcePredictor());
  const [resourcePredictions, setResourcePredictions] = useState([]);
  const [modelState, setModelState] = useState({
    waterTrained: false,
    propaneTrained: false,
    isLoading: false,
    error: null
  });

  const loadAndTrain = useCallback(async () => {
    if (productionPredictions.length === 0) return;
    
    setModelState(prev => ({ ...prev, isLoading: true, error: null }));

    try {
      const records = await getData('lainsa_records');
      if (!Array.isArray(records)) return;

      predictor.addTrainingData(records);
      
      // Тренуємо моделі
      const waterModel = predictor.trainWaterModel();
      const propaneModel = predictor.trainPropaneModel();

      setModelState({
        waterTrained: !!waterModel,
        propaneTrained: !!propaneModel,
        isLoading: false,
        error: null
      });

      // Генеруємо прогнози
      const predictions = predictor.predictConsumption(productionPredictions);
      setResourcePredictions(predictions);

    } catch (error) {
      console.error('Resource prediction error:', error);
      setModelState(prev => ({
        ...prev,
        error: error.message,
        isLoading: false
      }));
    }
  }, [predictor, productionPredictions]);

  useEffect(() => {
    if (productionPredictions.length > 0) {
      loadAndTrain();
    }
  }, [productionPredictions, loadAndTrain]);

  return {
    resourcePredictions,
    modelState,
    stats: predictor.getModelStats(),
    refreshPredictions: loadAndTrain
  };
};

// Експорт за замовчуванням для зручності
export default useResourcePredictions;


